import React, { useEffect, useState } from 'react'
import RoleService from '../../../services/KangarooServices/RoleService'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const RoleDetails = ({isOpen,toggle,id}) => {
    const [data,setData] = useState([]);

    const fetchDetail = async(id) => {
        try{
            const result = await RoleService.getbyId(id);
            setData(result);
        }catch(error){
            console.log(error);
        }
    };
    useEffect(() => {
        fetchDetail(id);
    },[id]);
  return (
    <div>
      {/* Optional: Button to manually open modal */}
      {/* <Button color="info" onClick={() => fetchDetail(id)}>View Details</Button> */}

      {data && (
        <Modal isOpen={isOpen} toggle={toggle}>
          <ModalHeader toggle={toggle}>Role Details</ModalHeader>
          <ModalBody>
            {/* <p><strong>ID:</strong> {data.id}</p> */}
            <p><strong>Name:</strong> {data.name}</p>
            <p><strong>Description:</strong> {data.description}</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggle}>Close</Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  )
}

export default RoleDetails
